import { CSS_BREAKPOINTS } from '@sbercloud/uikit-product-utils';
import { ItemId } from '@snack-uikit/list';
import { PropsWithChildren } from 'react';

import { useServerDataCtx } from '@/hooks/ctx';
import { useLayoutType } from '@/hooks/useLayoutType';
import { Predicate } from '@/types/common';
import { isLargeThan } from '@/utils/layout';

import { LayoutSectionWrapper } from './LayoutSectionWrapper';
import { PageNavigation, PageNavigationProps } from './PageNavigation';

type SectionWithNavigationProps = PropsWithChildren<
  PageNavigationProps & { layoutClassName?: string; getActiveElementParentIdsPred?: Predicate<ItemId[]> }
>;

export function SectionWithNavigation({
  children,
  TOCList,
  TOCClassName,
  rootClassName,
  layoutClassName,
  getActiveElementParentIdsPred,
}: SectionWithNavigationProps) {
  const { headers } = useServerDataCtx();
  const layoutType = useLayoutType(CSS_BREAKPOINTS, headers.xLayoutType);

  if (isLargeThan('tablet', layoutType)) {
    return (
      <LayoutSectionWrapper className={layoutClassName}>
        <PageNavigation
          getActiveElementParentIdsPred={getActiveElementParentIdsPred}
          TOCClassName={TOCClassName}
          rootClassName={rootClassName}
          TOCList={TOCList}
        >
          {children}
        </PageNavigation>
      </LayoutSectionWrapper>
    );
  }

  return (
    <PageNavigation
      getActiveElementParentIdsPred={getActiveElementParentIdsPred}
      TOCClassName={TOCClassName}
      rootClassName={rootClassName}
      TOCList={TOCList}
    >
      <LayoutSectionWrapper className={layoutClassName}>{children}</LayoutSectionWrapper>
    </PageNavigation>
  );
}
